export function FooterIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.4 20.8H7.6a4.402 4.402 0 01-4.261-3.3H20.66a4.402 4.402 0 01-4.261 3.3zM3.2 7.6v7.7h17.6V7.6a4.4 4.4 0 00-4.4-4.4H7.6a4.4 4.4 0 00-4.4 4.4zM7.6 23A6.6 6.6 0 011 16.4V7.6A6.6 6.6 0 017.6 1h8.8A6.6 6.6 0 0123 7.6v8.8a6.6 6.6 0 01-6.6 6.6H7.6zM9.403 9.327a.974.974 0 000 1.473l1.901 1.673c.394.347.998.347 1.392 0l1.901-1.674a.975.975 0 000-1.472 1.061 1.061 0 00-1.392 0L12 10.388l-1.205-1.061a1.061 1.061 0 00-1.392 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
